export enum Lenguages {
  "es",
}

export const Langs: Array<{ text: string; value: string; logo: string }> = [
  // { text: "English", value: "en", logo: "en.png" },
  { text: "Español", value: "es", logo: "es.png" },
];
